import styled from "styled-components"
import backgroundImage from "../../media/background.jpg"

export const Wrapper = styled.div`
  min-width:1200px;
  max-width:1200px;
  min-height:680px;
  max-height:680px;
  position:relative;
  background:url("${backgroundImage}") center no-repeat white;
  margin:30px auto;
  user-select:none;
`
